import React from 'react';
import {
  Alert,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import { IExecutiveReadiness } from './executiveReview.models';
type Props = { readiness: IExecutiveReadiness };
class ExecutiveReadinessPanel extends React.PureComponent<Props> {
  render() {
    const r = this.props.readiness;
    return (
      <Stack spacing={2}>
        <Card elevation={1}>
          <CardContent>
            <Typography variant="caption" color="text.secondary">
              Recommendation Readiness
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 900 }}>
              {r.score || 0}%
            </Typography>
            <LinearProgress
              variant="determinate"
              value={r.score || 0}
              sx={{ height: 9, borderRadius: 5, mt: 1 }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {r.message || 'Select a scenario to assess readiness.'}
            </Typography>
          </CardContent>
        </Card>
        <Grid container spacing={2}>
          {(r.items || []).map((x) => (
            <Grid size={{ xs: 12, md: 6 }} key={x.code}>
              <Alert
                severity={
                  x.passed
                    ? 'success'
                    : x.severity === 'BLOCKING'
                      ? 'error'
                      : 'warning'
                }
              >
                <b>{x.label}</b>
                {x.message ? `: ${x.message}` : ''}
              </Alert>
            </Grid>
          ))}
        </Grid>
      </Stack>
    );
  }
}
export default ExecutiveReadinessPanel;
